module.exports = __webpack_public_path__ + "img/www.airbnb.ca.86baa7fa.png";